import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { date } from '../../utils/parsing';
import { AUTH_LEVELS } from '../auth/Authorized';
import BuildingsLoader from '../loaders/BuildingsLoader';
import DataRequestsLoader from '../loaders/DataRequestsLoader';
import UsersLoader from '../loaders/UsersLoader';
import Target from '../actionLog/Target';
import Status from './Status';

import './past-requests.css';

export const getVariant = (userAuthLevel) => {
  if (userAuthLevel <= AUTH_LEVELS.SUPER_ADMIN) return 'super-admin';
  if (userAuthLevel <= AUTH_LEVELS.ORG_ADMIN) return 'org-admin';
  return 'user';
};

const PastRequests = ({ requests, variant, loaded }) => {
  let inner;
  if (!loaded) {
    inner = <LinearProgress color="secondary" style={{ width: '400px' }} />;
  } else if (requests.length === 0) {
    inner = <Typography variant="h5">No requests yet</Typography>;
  } else {
    inner = (
      <Table>
        <TableHead className="header">
          <TableRow>
            <TableCell>Project Name</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Tracking Number</TableCell>
            {variant !== 'user' && <TableCell>By</TableCell>}
            <TableCell>Last Modified</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {requests.map((r) => (
            <TableRow key={r.id}>
              <TableCell>
                <Link to={`/data-request/edit/${r.id}`}>
                  {r.building_id > 0 ? (
                    <Target type="building" id={r.building_id} />
                  ) : (
                    r.name || 'unnamed'
                  )}
                </Link>
              </TableCell>
              <TableCell>
                <Status text={r.status} />
              </TableCell>
              <TableCell>{r.tracking_number}</TableCell>
              {variant !== 'user' && (
                <TableCell>
                  <Target type="user" id={r.created_by} />
                </TableCell>
              )}
              <TableCell>{date(r.last_modified)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }
  return (
    <>
      <DataRequestsLoader variant={variant} />
      <BuildingsLoader />
      <UsersLoader />
      {inner}
    </>
  );
};

export default connect(
  ({
    user: { userAuthLevel },
    entities: {
      dataRequests: { all: requests, loaded },
    },
  }) => ({
    requests,
    variant: getVariant(userAuthLevel),
    loaded,
  })
)(PastRequests);
